export default "__VITE_ASSET__Cj70ti32__"